<template>
  <div class="date-range-picker">
    <el-date-picker
      v-model="dateRange"
      type="daterange"
      range-separator="至"
      start-placeholder="开始日期"
      end-placeholder="结束日期"
      :size="size"
      :disabled="disabled"
      :clearable="clearable"
      :shortcuts="shortcuts"
      :format="format"
      :value-format="valueFormat"
      @change="handleChange"
    />
  </div>
</template>

<script setup>
import { ref, watch, computed } from 'vue';
import dayjs from 'dayjs';

const props = defineProps({
  modelValue: {
    type: Array,
    default: () => []
  },
  size: {
    type: String,
    default: 'default'
  },
  disabled: {
    type: Boolean,
    default: false
  },
  clearable: {
    type: Boolean,
    default: true
  },
  format: {
    type: String,
    default: 'YYYY-MM-DD'
  },
  valueFormat: {
    type: String,
    default: 'YYYY-MM-DD'
  },
  showShortcuts: {
    type: Boolean,
    default: true
  }
});

const emit = defineEmits(['update:modelValue', 'change']);

const dateRange = ref(props.modelValue);

// 监听modelValue变化
watch(() => props.modelValue, (newVal) => {
  dateRange.value = newVal;
});

// 监听日期范围变化
watch(dateRange, (newVal) => {
  emit('update:modelValue', newVal);
});

// 处理日期变更
const handleChange = (value) => {
  emit('change', value);
};

// 快捷选项
const shortcuts = computed(() => {
  if (!props.showShortcuts) return [];
  
  return [
    {
      text: '最近一周',
      value: () => {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
        return [start, end];
      }
    },
    {
      text: '最近一个月',
      value: () => {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
        return [start, end];
      }
    },
    {
      text: '最近三个月',
      value: () => {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
        return [start, end];
      }
    },
    {
      text: '本学期',
      value: () => {
        // 假设上学期为9月1日至次年1月31日，下学期为2月1日至6月30日
        const now = new Date();
        const year = now.getFullYear();
        const month = now.getMonth() + 1;
        
        let start, end;
        if (month >= 9) {
          // 上学期
          start = new Date(year, 8, 1); // 9月1日
          end = new Date(year + 1, 0, 31); // 次年1月31日
        } else if (month >= 2 && month <= 7) {
          // 下学期
          start = new Date(year, 1, 1); // 2月1日
          end = new Date(year, 5, 30); // 6月30日
        } else {
          // 寒暑假，默认显示当前月
          start = new Date(year, now.getMonth(), 1);
          end = new Date(year, now.getMonth() + 1, 0);
        }
        
        return [start, end];
      }
    }
  ];
});
</script>

<style scoped>
.date-range-picker {
  display: inline-block;
}
</style> 